"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fp = require("lodash/fp");

var _recompose = require("recompose");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var _Icon = _interopRequireDefault(require("@emcasa/ui-dom/components/Icon"));

var _Text = _interopRequireDefault(require("@emcasa/ui-dom/components/Text"));

var _Row = _interopRequireDefault(require("@emcasa/ui-dom/components/Row"));

var _Col = _interopRequireDefault(require("@emcasa/ui-dom/components/Col"));

var _styles = require("./styles");

var _grid = require("../styles/grid");

var isValidFile = function isValidFile(file) {
  return /^image\//.test(file.type);
};

var groupFiles = (0, _fp.groupBy)(function (file) {
  return isValidFile(file) ? 'accepted' : 'rejected';
});
var fileTarget = {
  drop: function drop(props, monitor) {
    var item = monitor.getItem();
    if (!item.files || !item.files.length) return;

    var _groupFiles = groupFiles(item.files),
        accepted = _groupFiles.accepted,
        rejected = _groupFiles.rejected; // Time to actually perform the action


    if (props.onDrop) props.onDrop(accepted, rejected);
  }
};
var Target = (0, _reactDnd.DropTarget)(_reactDndHtml5Backend.NativeTypes.FILE, fileTarget, function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
});

var FileTarget =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(FileTarget, _PureComponent);

  function FileTarget() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, FileTarget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(FileTarget)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "inputRef", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openFileExplorer", function () {
      if (_this.inputRef.current) {
        _this.inputRef.current.value = null;

        _this.inputRef.current.click();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSelectFiles", function (e) {
      var onDrop = _this.props.onDrop;
      e.preventDefault();
      var files = e.target.files;
      if (files.length && onDrop) onDrop(Array.from(files));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onInputClick", function (e) {
      e.stopPropagation();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTargetClick", function (e) {
      e.stopPropagation();
      e.preventDefault();
      setTimeout(_this.openFileExplorer, 1);
    });
    return _this;
  }

  (0, _createClass2["default"])(FileTarget, [{
    key: "renderProgress",
    value: function renderProgress() {
      var _this$props = this.props,
          progress = _this$props.progress,
          fontSize = _this$props.fontSize;
      return _react["default"].createElement(_Col["default"], {
        m: "5.5%"
      }, _react["default"].createElement(_Row["default"], {
        height: "40px",
        justifyContent: "center",
        alignItems: "center"
      }, _react["default"].createElement(_styles.Spinner, {
        size: 10
      })), _react["default"].createElement(_Text["default"], {
        inline: true,
        textAlign: "center",
        color: "pink",
        fontSize: fontSize
      }, "Subindo fotos ", progress[0], "/", progress[1]));
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var _this$props2 = this.props,
          fontSize = _this$props2.fontSize,
          iconSize = _this$props2.iconSize,
          hideText = _this$props2.hideText,
          disabled = _this$props2.disabled;
      var color = disabled ? 'disabled' : 'dark';
      return _react["default"].createElement(_Row["default"], {
        width: "100%",
        m: "5.5%",
        alignItems: "center",
        justifyContent: "center"
      }, _react["default"].createElement(_Row["default"], {
        mx: 2,
        justifyContent: "center",
        alignItems: "center"
      }, _react["default"].createElement(_Icon["default"], {
        color: color,
        size: iconSize,
        name: "arrow-up"
      })), !hideText && _react["default"].createElement(_Text["default"], {
        inline: true,
        fontWeight: "bold",
        color: color,
        fontSize: fontSize,
        lineHeight: 1.25
      }, "Adicionar", _react["default"].createElement("br", null), "imagens"));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          isOver = _this$props3.isOver,
          connectDropTarget = _this$props3.connectDropTarget,
          progress = _this$props3.progress,
          disabled = _this$props3.disabled;
      return _react["default"].createElement(_styles.UploadCard, {
        isActive: isOver,
        onClick: disabled ? undefined : this.onTargetClick,
        ref: connectDropTarget
      }, _react["default"].createElement("input", {
        ref: this.inputRef,
        multiple: true,
        type: "file",
        accept: "image/*",
        style: {
          display: 'none'
        },
        autoComplete: "off",
        tabIndex: "-1",
        onClick: this.onInputClick,
        onChange: this.onSelectFiles
      }), progress ? this.renderProgress() : this.renderButton());
    }
  }]);
  return FileTarget;
}(_react.PureComponent);

(0, _defineProperty2["default"])(FileTarget, "defaultProps", {
  fontSize: 16,
  iconSize: 30
});
(0, _defineProperty2["default"])(FileTarget, "propTypes", {
  hideText: _propTypes["default"].bool,
  fontSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  iconSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
});

var _default = (0, _recompose.compose)(_styledComponents.withTheme, (0, _recompose.withProps)((0, _grid.gridStyle)('UploadTarget')), Target)(FileTarget);

exports["default"] = _default;